import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './styles/Errors.css';
import { PrimaryButton } from '../Buttons';

const WorkspaceNotFound = ({ error, redirectDelay = 10 }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(redirectDelay);

  useEffect(() => {
    if (countdown <= 0) {
      navigate('/');
      return;
    }
    const timer = setTimeout(() => setCountdown(prev => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, navigate]);

  return (
    <div className="error-page">
      <img
        src="/images/flow-logo-tmp-branded.jpeg"
        alt={t('ui.workspace_not_found.logo_alt', 'Logo')}
        className="error-page__logo"
      />
      <h2 className="error-page__title">{t('ui.workspace_not_found.title', 'Workspace Not Found')}</h2>
      <p className="error-page__message">
        {error || t('ui.workspace_not_found.message', 'This workspace does not exist or has been removed.')}
      </p>
      <p className="error-page__countdown">
        {t('ui.workspace_not_found.redirecting', 'Redirecting to home in {{count}} second{{suffix}}...', {
          count: countdown,
          suffix: countdown !== 1 ? 's' : '',
        })}
      </p>
      <div className="error-page__actions">
        <div className='hyperlink' onClick={() => navigate('/')}>{t('ui.workspace_not_found.go_home', 'Go to Home')} <span className='material-symbols-sharp notranslate' style={{fontSize: 14}} notranslate>chevron_right</span></div>
      </div>
    </div>
  );
};

export default WorkspaceNotFound;